import React from 'react';

import { Grid, Typography, makeStyles, useTheme } from '@material-ui/core';
import i18n from 'i18n';
import {
  AvgMaxCountAccess,
  PeriodCountAccess,
  DateFilterFields,
} from 'modules/environments/interfaces';
import ApplicationState from 'store/interfaces';
import { connect } from 'react-redux';
import AutoCard from 'components/AutoCard';
import FilterSelector from 'components/FilterSelector';
import { filterAvgMaxOptions } from 'utils/graphs';
import {
  getEnvironmentPerformanceOperationalTimeRequest,
  setEnvironmentAvgMaxFilterOperationalTime,
} from 'modules/environments/actions';
import { useParams } from 'react-router';
import { modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import styles, {
  overrideCardGraph,
  overrideFilter,
  overrideModalGraph,
} from './styles';
import OperationalTimeGraph from './OperationalTimeGraph';
import OperationalTimeGraphModal from './OperationalTimeGraphModal';

interface OperationalTimeGraphCardProps {
  avgMaxFilter: AvgMaxCountAccess;
  dateFilter?: DateFilterFields;
  intervalTime: PeriodCountAccess;
  modalOpen: (props: ModalFields) => void;
  setEnvironmentAvgMaxFilterOperationalTime: (prop: string) => void;
  getEnvironmentPerformanceOperationalTimeRequest: ({ id, query }) => void;
}

const OperationalTimeGraphCard = ({
  avgMaxFilter,
  dateFilter,
  intervalTime,
  modalOpen,
  setEnvironmentAvgMaxFilterOperationalTime,
  getEnvironmentPerformanceOperationalTimeRequest,
}: OperationalTimeGraphCardProps) => {
  const classes = makeStyles(styles())();
  const { id } = useParams<{
    id: string;
  }>();
  const { breakpoints } = useTheme();

  const getEnvironmentPerformanceOperationalTime = React.useCallback(() => {
    const query =
      dateFilter?.['start-date'] && dateFilter?.['end-date']
        ? dateFilter
        : { period: intervalTime };

    getEnvironmentPerformanceOperationalTimeRequest({
      id,
      query,
    });
  }, [
    getEnvironmentPerformanceOperationalTimeRequest,
    intervalTime,
    id,
    dateFilter,
  ]);

  React.useEffect(() => {
    getEnvironmentPerformanceOperationalTime();
  }, [getEnvironmentPerformanceOperationalTime]);

  const handleOpenGraphModal = () => {
    modalOpen({
      overrideClasses: overrideModalGraph,
      maxWidth: 'xl',
      title: i18n.t('PERFORMANCE_PAGE.OPERATIONAL_TIME_DETAILS_KEY'),
      content: <OperationalTimeGraphModal />,
      onClose: () => getEnvironmentPerformanceOperationalTime(),
      genericFooter: {},
    });
  };

  return (
    <Grid item className={classes.containerCard}>
      <Grid item>
        <Grid container alignItems="center" justify="space-between">
          <Grid item>
            <Typography className={classes.graphTitle}>
              {i18n.t('MONITORING_PAGE.OPERATING_TIME_KEY')}
            </Typography>
          </Grid>
          <Grid item className={classes.gridFilters}>
            <FilterSelector
              overrideClasses={overrideFilter}
              options={filterAvgMaxOptions(
                setEnvironmentAvgMaxFilterOperationalTime
              )}
              currentValue={{
                label: i18n.t(
                  `PERFORMANCE_PAGE.${avgMaxFilter.toUpperCase()}_KEY`
                ),
                onClick: () => null,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <AutoCard overrideClasses={overrideCardGraph(breakpoints)}>
        <Grid
          container
          className={classes.containerGraph}
          onClick={handleOpenGraphModal}
        >
          <OperationalTimeGraph filter={avgMaxFilter} />
        </Grid>
      </AutoCard>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { periodFilter, environmentAvgMaxFilterOperationalTime },
}: ApplicationState) => ({
  intervalTime: periodFilter,
  avgMaxFilter: environmentAvgMaxFilterOperationalTime,
});
export default connect(mapStateToProps, {
  setEnvironmentAvgMaxFilterOperationalTime,
  getEnvironmentPerformanceOperationalTimeRequest,
  modalOpen,
})(OperationalTimeGraphCard);
